/* eslint-disable */
import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function getEmployees(query: string, oldData?: any) {
	error.value = null;
	try {
		const q = query && query?.length > 0 ? `/search?query=${query}` : '';
		const res = await $api.staff.getEmployees(q, oldData);
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
	} finally {
		loading.value = false;
	}
}

export async function getSimpleStaffs() {
	error.value = null;
	try {
		const res = await $api.staff.getSimpleStaffs();
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
	} finally {
		loading.value = false;
	}
}

export function useGetEmployees() {
	return { error, loading, getEmployees, getSimpleStaffs };
}
